/**
 * Format number to Vietnamese currency format
 * @param {number} amount - The amount to format
 * @returns {string} Formatted currency string (e.g., "1.000.000 VND")
 */
export const formatCurrency = (amount) => {
  if (amount === null || amount === undefined || isNaN(amount)) {
    return '0 VND';
  }

  return new Intl.NumberFormat('vi-VN', {
    style: 'currency',
    currency: 'VND',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).format(amount);
};

/**
 * Format number to Vietnamese number format without currency symbol
 * @param {number} amount - The amount to format
 * @returns {string} Formatted number string (e.g., "1.000.000")
 */
export const formatNumber = (amount) => {
  if (amount === null || amount === undefined || isNaN(amount)) {
    return '0';
  }

  return new Intl.NumberFormat('vi-VN').format(amount);
};
